$(function () {
  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", function (event) {
    const divisionMultiplier = CPB.getStore()
      .getState()
      .Product.metafields.find((field) => field.key === "divisionMultiplier");
    window.priceDivisionMultiplier = divisionMultiplier
      ? +divisionMultiplier.value
      : 10; // У них в старой теме просто в файле продукта была эта переменная создана непонятно зачем. Перенес сюда в том виде как была там
    var priceDivisionMultiplier = window.priceDivisionMultiplier;
    var $root;
    var shopId = "";
    var Parcelamento = function (priceEl) {
      this.priceEl = priceEl;
      var div = $("<div>")
        .addClass("installments-plugin-snippet")
        .css("display", "none");
      var priceS = $("<span>").html(this.getPrice());
      div
        .append("ou " + priceDivisionMultiplier + "x de ")
        .append(priceS)
        .append(" sem juros!");

      var observer = new MutationObserver(
        function () {
          priceS.html(this.getPrice());
        }.bind(this)
      );

      observer.observe(this.priceEl, { characterData: true, subtree: true });
      return div[0];
    };
    Parcelamento.prototype.getPrice = function () {
      return (
        this.priceEl.innerText.substr(
          0,
          this.priceEl.innerText.search(/[0-9]/)
        ) +
        Math.round(
          CPB.getStore().getState().Product.price / priceDivisionMultiplier
        ) +
        ",00"
      );
    };
    var initParcelamento = function () {
      var priceWrap = document.querySelector(".cpb-product-price");
      var priceEl = priceWrap.querySelector("span");
      console.log(priceEl, "priceEl")
      priceWrap.appendChild(new Parcelamento(priceWrap));

      var summary = document.querySelector(".cpb-selection-summary-total");
      if (summary) summary.appendChild(new Parcelamento(priceEl));
    };
    var initRating = function () {
      if ($(".cpb-product-title").length)
        $(".cpb-product-title").after($("#rating-badge").css("display", ""));
      else
        $(".cpb-panels-container").prepend(
          $("#rating-badge").css("display", "")
        );
    };
    var getProductConfigUrl = function () {
      window._cpb.saveConfig(function (res) {
        var configId = window._cpb.saveConfig(null, false);
        var url = window.location.href + "?configid=" + configId;
        window.open(url, "_blank"); // product preview
      }, false);
    };
    var customJS = function () {
      $root = $("#product-builder");
      var $addition = $(
        '<div style="display: none;"><button type="button">GET CONFIG</button></div>'
      );
      $root.find(".cpb-product-actions").append($addition);
      $addition.find("button").on("click", getProductConfigUrl);

      // initParcelamento();

      initRating();

      $(".cpb-agreement-checkbox").trigger("click");
    };
    var loadCpb = function () {
      if ($(".cpb-add-to-cart-button span").length) {
        customJS();
      } else {
        window.requestAnimationFrame(loadCpb);
      }
    };
    loadCpb();

    const productPreview = document.querySelector(".cpb-preview-sticky");
    console.log(productPreview, "productPreview");
    const customTitle = document.createElement("h1");
    customTitle.classList.add("cpb-custom-title");
    console.log(customTitle, "customTitle");
    customTitle.textContent = CPB.getStore().getState().Product.name;
    productPreview.prepend(customTitle);
  });
});
